<script setup lang="ts">
defineOptions({
	name: 'PersonalDataSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-material-symbols:alarm-on-outline-rounded"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Personal Data Retention Period') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>
				{{
					$t(
						'Personal Data collected through the Platform is processed in strict compliance with applicable legislation and stored in dedicated databases created for this purpose. This Personal Data is maintained in a format that permits the identification of Data Subjects only for as long as is necessary for the purposes for which it is processed',
					)
				}}.
			</p>
			<p>
				{{
					$t(
						'The retention period for Personal Data varies according to the purpose for which the information is used. Nonetheless, there are legal requirements that mandate the retention of certain Personal Data for a specific period',
					)
				}}.
			</p>
			<p>
				{{
					$t(
						'In the absence of any such legal requirements, Personal Data will be stored and retained only for the minimum period necessary for the purposes for which it was collected or subsequently processed, or as long as the account remains active and, if no other term applies, for a period of one year after the account being closed, to safeguard the obligations, interactions, and transactions carried out, after which it will be deleted',
					)
				}}.
			</p>
		</div>
	</section>
</template>
